/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import SocialShares from "./SocialShares";
import EmailLogo from "../images/email.webp";

const Hashids = require("hashids/cjs");

const modalStyle = {
  overlay: {
    zIndex: 20,
    backgroundColor: "rgba(17, 30, 25, 0.72)",
  },
  content: {
    position: "absolute",
    zIndex: 20,
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    border: 0,
    background: "rgb(255, 255, 255)",
    overflow: "auto",
    borderRadius: "4px",
    outline: "none",
    padding: "0px",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    maxWidth: "550px",
    maxHeight: "710px",
    boxShadow:
      "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  },
};

const SignupConfirmationModal = ({
  closeModal,
  modalState,
  email,
  referralCode,
  waitlistPosition,
}) => {
  if (document) {
    Modal.setAppElement("body");
  }

  const [referral, setReferral] = useState(null);
  const referralUrl = () =>
    `https://tomocredit.com/?referral=${referralCode || referral}`;

  const generateReferralCode = (emailInput) => {
    const hashids = new Hashids(
      emailInput,
      6,
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890",
    );
    const rand = () => Math.floor(Math.random() * 100);
    return hashids.encode(1, 2, rand());
  };

  useEffect(() => {
    if (!referralCode) {
      setReferral(generateReferralCode(email));
    }
  }, []);

  const renderSimpleShare = () => (
    <div className="py-4">
      <div className="inline-block align-middle">Share on:</div>
      <SocialShares
        url={referralUrl()}
        quote={`I'm ${
          waitlistPosition ? `#${waitlistPosition}` : ``
        } on the waitlist for TomoCredit! Sign up with me and we can share the loot!`}
        className="inline-flex justify-center align-middle"
        subcomponentClassName="inline-block overflow-hidden rounded"
        iconBgColor="transparent"
        logoColor="#58fdd9"
        hoverColor="#4b4b57"
      />
    </div>
  );

  const renderLinkedInPixel = () => (
    <img
      alt=""
      height={1}
      width={1}
      style={{ display: "none" }}
      src="https://px.ads.linkedin.com/collect/?pid=3558916&conversionId=5426356&fmt=gif"
    />
  );

  const renderRedirectToBoost = () => {
    return (
      <div className="flex flex-col items-center text-white font-semibold mt-4 mx-5">
        <div>{`Don't forget to checkout our limited Instant Credit Score Boost product!`}</div>
        <a
          href="/boost-pricing"
          className="my-4 btn cursor-pointer rounded-lg text-center font-body px-6 py-3 font-semibold text-lg bg-boost-primary-purple grow-0 shadow-2xl xxl:w-auto hover:bg-purple-700 text-boost-txt-white"
        >
          TomoBoost
        </a>
      </div>
    );
  };

  const renderCheckEmail = () => {
    return (
      <div className="pt-6 text-white" style={{ backgroundColor: "#151519" }}>
        <div className="mb-4 sm:px-6 md:px-20 lg:px-8 pt-4">
          <h3 className="px-5 font-header font-bold text-2xl">
            <span>Awesome!</span>
          </h3>
          <div className="flex justify-center py-2 mr-5">
            <img alt="" className="h-24" src={EmailLogo} />
          </div>
          <h4 className="font-bold mt-2 text-md w-10/12 mx-auto">
            Your card is reserved!
          </h4>
        </div>
        {renderRedirectToBoost()}
        <div>
          <div
            className="flex justify-center py-6 border-black border-t cursor-pointer"
            onClick={closeModal}
          >
            <input
              type="button"
              className="flex justify-center bg-transparent cursor-pointer outline-none"
              value="Close"
            />
          </div>
        </div>
        {/* {renderLinkedInPixel()} */}
      </div>
    );
  };

  const renderBoostEnrolledWithNoLogin = () => {
    return (
      <div className="pt-6 text-white" style={{ backgroundColor: "#151519" }}>
        <div className="mb-4 sm:px-6 md:px-20 lg:px-8 pt-4">
          <h3 className="px-5 font-header font-bold text-2xl">
            <span>Awesome!</span>
          </h3>
          <div className="flex justify-center py-2 mr-5">
            <img alt="" className="h-24" src={EmailLogo} />
          </div>
          <h4 className="font-bold mt-2 text-md w-10/12 mx-auto">
            Your are enrolled in TomoBoost!
            <br />
            Check your email to finish setting up your account.
          </h4>
          <p className="mt-4 text-md w-10/12 mx-auto">
            Don&apos;t see an email? Check Spam.
          </p>
        </div>
        <div>
          <div
            className="flex justify-center py-6 border-black border-t cursor-pointer"
            onClick={closeModal}
          >
            <input
              type="button"
              className="flex justify-center bg-transparent cursor-pointer outline-none"
              value="Close"
            />
          </div>
        </div>
        {renderLinkedInPixel()}
      </div>
    );
  };

  const renderResumeApplication = () => {
    return (
      <div className="pt-6 text-white" style={{ backgroundColor: "#151519" }}>
        <div className="mb-4 sm:px-6 md:px-20 lg:px-8 pt-4">
          <h3 className="px-5 font-header font-bold text-2xl">
            <span>Welcome Back!</span>
          </h3>
          <h4 className="font-bold mt-4 text-md w-10/12 mx-auto">
            Did you mean to...
          </h4>
          <button
            type="button"
            className="mt-4 btn cursor-pointer rounded-lg text-center font-body px-6 py-3 font-semibold text-lg bg-primary-btn flex-grow-0 shadow-2xl xxl:w-auto hover:bg-greenHover"
            style={{
              outline: "none",
              minWidth: 220,
              boxShadow: "rgb(86 45 100 / 15%) 13px 11px 36px -10px",
            }}
            onClick={() => {
              window.location = `/register/login`;
            }}
          >
            <span className="text-primary-dark">Resume Your Application</span>
          </button>
        </div>
        {renderRedirectToBoost()}
        {renderSimpleShare()}
        <div className="">
          <div
            className="flex justify-center py-6 border-black border-t cursor-pointer"
            onClick={closeModal}
          >
            <input
              type="button"
              className="flex justify-center bg-transparent cursor-pointer outline-none"
              value="Close"
            />
          </div>
        </div>
      </div>
    );
  };

  const renderLogin = () => {
    return (
      <div className="pt-6 text-white" style={{ backgroundColor: "#151519" }}>
        <div className="mb-4 sm:px-6 md:px-20 lg:px-8 pt-4">
          <h3 className="px-5 font-header font-bold text-2xl">
            <span>Welcome Back!</span>
          </h3>
          <h4 className="font-bold mt-4 text-md w-10/12 mx-auto">
            Did you mean to...
          </h4>
          <button
            type="button"
            className="mt-4 btn cursor-pointer rounded-lg text-center font-body px-6 py-3 font-semibold text-lg bg-primary-btn flex-grow-0 shadow-2xl xxl:w-auto hover:bg-greenHover"
            style={{
              outline: "none",
              minWidth: 220,
              boxShadow: "rgb(86 45 100 / 15%) 13px 11px 36px -10px",
            }}
            onClick={() => {
              window.location = `/dashboard/login`;
            }}
          >
            <span className="text-primary-dark">Log In</span>
          </button>
        </div>
        {renderRedirectToBoost()}
        {renderSimpleShare()}
        <div>
          <div
            className="flex justify-center py-6 border-black border-t cursor-pointer"
            onClick={closeModal}
          >
            <input
              type="button"
              className="flex justify-center bg-transparent cursor-pointer outline-none"
              value="Close"
            />
          </div>
        </div>
      </div>
    );
  };

  const renderAlreadyApplied = () => {
    return (
      <div className="pt-6 text-white" style={{ backgroundColor: "#151519" }}>
        <div className="mb-4 sm:px-6 md:px-20 lg:px-8 pt-4">
          <h3 className="px-5 font-header font-bold text-2xl">
            <span>Hi there!</span>
          </h3>
          <h4 className="font-bold mt-4 text-md w-10/12 mx-auto">
            We see that you&apos;ve already applied with us.
          </h4>
        </div>
        {renderRedirectToBoost()}
        {renderSimpleShare()}
        <div>
          <div
            className="flex justify-center py-6 border-black border-t cursor-pointer"
            onClick={closeModal}
          >
            <input
              type="button"
              className="flex justify-center bg-transparent cursor-pointer outline-none"
              value="Close"
            />
          </div>
        </div>
      </div>
    );
  };

  const renderModal = () => {
    switch (modalState) {
      case "login":
        return renderLogin();
      case "resume":
        return renderResumeApplication();
      case "applied":
        return renderAlreadyApplied();
      case "boostEnrolledWithNoLogin":
        return renderBoostEnrolledWithNoLogin();
      default:
        return renderCheckEmail({ email });
    }
  };

  return (
    <Modal
      isOpen={!!modalState}
      onRequestClose={closeModal}
      style={modalStyle}
      contentLabel="Example Modal"
    >
      <div
        className="close text-gray-500 mt-4 cursor-pointer"
        data-dismiss="modal"
        onClick={closeModal}
      >
        &times;
      </div>
      <div
        className="modal fade h-full"
        id="myModal"
        role="dialog"
        aria-labelledby="myModalLabel"
      >
        <div className="modal-dialog h-full">
          <div className="modal-content h-full">
            <div className="modal-body rounded-sm font-text">
              {renderModal()}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SignupConfirmationModal;
